import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import userProfiler from "web/script/modules/userprofiler";
import globals from "web/script/modules/globals";
import { fromString } from "web/script/dom/factory";

import "web/script/components/ajax-form";
import "web/script/components/auth/social-auth-button";
import "web/script/components/ga-client-id-input";
import "web/script/components/tracked-link";

export default baustein.register("signup-form", {
    defaultOptions: {
        registrationReason: "normal",
        eventCategory: "unknown",
        isLogin: false,
        pageType: "signup_form",
    },

    init() {
        const seenProducts = userProfiler.getSeenProducts();
        if (seenProducts) {
            const productIds = seenProducts.reduce((memo, product) => {
                memo.push(product.productId);
                return memo;
            }, []);
            let hiddenProductIds = this.el.querySelector('[name="invisible_pids"]');
            hiddenProductIds.value = productIds.join(",");
        }
    },

    setupEvents(add) {
        add("submit", "form", this.onFormSubmit);
        add("form-submit-success", "ajax-form", this.onSubmitSuccess);
        add("click", '[name="privacy_policy"]', this.onPrivacyPolicyChange);
        add("click", '[name="marketing_emails"]', this.onMarketingEmailsChange);
        add("signup-legal-required", this._handleSignupErrors);
        add("click", ".form-input-text", this.onFormClick);
    },

    onFormClick: function(event, element) {
        let name = element.name;
        if (name === "username") {
            name = "email";
        }
        analytics.event(this.options.eventCategory, "fill_field", "field_" + name);
    },

    onPrivacyPolicyChange() {
        const privacyPolicyValue = this.el.querySelector('[name="privacy_policy"]').checked;
        let action = "untick_box";
        if (privacyPolicyValue) {
            action = "tick_box";
        }
        analytics.event(this.options.eventCategory, action, "tickbox_privacy_policy");
        let components = this.findComponents("social-auth-button");
        for (const component of components) {
            component.updateOptions({ privacyPolicy: privacyPolicyValue });
        }
    },

    onMarketingEmailsChange() {
        const marketingEmailsValue = this.el.querySelector('[name="marketing_emails"]').checked;
        let action = "untick_box";
        if (marketingEmailsValue) {
            action = "tick_box";
        }
        analytics.event(this.options.eventCategory, action, "tickbox_marketing");
        let components = this.findComponents("social-auth-button");
        for (const component of components) {
            component.updateOptions({ marketingEmails: marketingEmailsValue });
        }
    },

    /**
     * Tracking for form submit
     */
    onFormSubmit(event) {
        event.preventDefault();
        let action = "click_signup_button";
        let label = "signup_button";
        if (this.options.isLogin) {
            action = "click_signin_button";
            label = "signin_button";
        }
        analytics.event(this.options.eventCategory, action, label);
    },

    onSubmitSuccess(event) {
        let response = event.formData;
        if (response.success) {
            // set a param so save-for-later callout is shown on page reload
            if (response.data && response.data.redirect_url) {
                globals.window.location = response.data.redirect_url;
            } else {
                globals.window.location = response.next;
            }
        } else {
            this._handleSignupErrors(response.data.errors);
        }
    },

    _clearErrors() {
        Array.from(this.el.querySelectorAll(".form-item-error")).forEach((element) => {
            element.parentElement.removeChild(element);
        });
    },

    _showError(errorMessage, errorSelector) {
        const item = this.el.querySelector(errorSelector);
        if (item) {
            item.appendChild(fromString(`<div class="form-item-error">${errorMessage}</div>`));
        }
    },

    _handleSignupErrors(errors) {
        this._clearErrors();
        if ("email" in errors) {
            let errorMsg = errors["email"].join(" ");
            analytics.event(this.options.eventCategory, "missing_email_signin", "field_email");
            this._showError(errorMsg, ".auth-form__email");
        }
        if ("existing_user" in errors) {
            let errorMsg = errors["existing_user"].join(" ");
            analytics.event(this.options.eventCategory, "email_exist", "field_email");
            this._showError(errorMsg, ".auth-form__email");
        }
        if ("username" in errors) {
            let errorMsg = errors["username"].join(" ");
            analytics.event(this.options.eventCategory, "blank_email_field", "field_email");
            this._showError(errorMsg, ".auth-form__email");
        }

        if ("password" in errors) {
            let errorMsg = errors["password"].join(" ");
            if (errorMsg.indexOf("This password") > -1) {
                analytics.event(
                    this.options.eventCategory,
                    "wrong_password_format",
                    "field_password"
                );
            } else {
                analytics.event(
                    this.options.eventCategory,
                    "missing_password_signin",
                    "field_password"
                );
            }
            this._showError(errorMsg, ".auth-form__password");
        }

        if ("privacy_policy" in errors) {
            let errorMsg = errors["privacy_policy"].join(" ");
            analytics.event(this.options.eventCategory, "missed_tickbox", "tickbox_privacy_policy");
            this._showError(errorMsg, ".form-item-legal__gdpr");
        }

        if ("__all__" in errors) {
            let errorMsg = errors["__all__"].join(" ");
            analytics.event(
                this.options.eventCategory,
                "wrong_signin",
                "wrong_email_or_password_signin"
            );
            this._showError(errorMsg, ".form-item-generic");
        }
    },
});
